import React from 'react';

export default ({ children, ...props }) => (
  <button type="button" className="button-link" {...props}>
    {children}
  </button>
);



// WEBPACK FOOTER //
// ./src/components/ButtonLink.js